import moment from 'moment';

export default (value) => {
  if (!value) return '';
  // moment.locale(locale || 'en');
  return moment.utc(value).local().fromNow();
};



// WEBPACK FOOTER //
// ./src/filter/diff-for-humans.js